function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo, useRef, useEffect } from 'react';
import RecordEditorForm from '../RecordEditor/RecordEditorForm';
import CheckboxWidget from '../Widgets/CheckboxWidget';
import CheckboxesWidget from '../Widgets/CheckboxesWidget';
import DateWidget from '../Widgets/DateWidget';
import LikertWidget from '../Widgets/LikertWidget';
import RadioWidget from '../Widgets/RadioWidget';
import RichTextWidget from '../Widgets/RichtextWidget';
import SelectWidget from '../Widgets/SelectWidget';
import SortDirectionWidget from '../../Tables/SortDirectionWidget';
import TextAreaWidget from '../Widgets/TextareaWidget';
import TextWidget from '../Widgets/TextWidget';
import ThemeContext from '../../ThemeContext';
import wrapCVIReviewWidget from '../Widgets/wrapCVIReviewWidget';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import en from './locales/CVIReviewForm.en.json';
import RECORD_EDITOR_FROALA_CONFIG from '../RecordEditor/Widgets/recordEditorFroalaConfig';
var WIDGETS = {
  checkbox: wrapCVIReviewWidget(CheckboxWidget),
  checkboxes: wrapCVIReviewWidget(CheckboxesWidget),
  date: wrapCVIReviewWidget(DateWidget),
  likert: wrapCVIReviewWidget(LikertWidget),
  radio: wrapCVIReviewWidget(RadioWidget),
  richtext: wrapCVIReviewWidget(function (props) {
    return /*#__PURE__*/React.createElement(RichTextWidget, Object.assign({
      config: RECORD_EDITOR_FROALA_CONFIG
    }, props));
  }),
  select: wrapCVIReviewWidget(SelectWidget),
  sort: wrapCVIReviewWidget(SortDirectionWidget),
  text: wrapCVIReviewWidget(TextWidget),
  textarea: wrapCVIReviewWidget(TextAreaWidget)
};

// @todo
// changes the title if needed to highlight things
// eventually also rolls up question groups that are dates

var messages = normalizeLocaleData(en, '@dm/components.cvi-review-form');
export default function CVIReviewForm(props) {
  var widgets = useMemo(function () {
    return _objectSpread({}, WIDGETS, props.widgets);
  }, [props.widgets]);
  var formRef = useRef(null);
  var submitTimeout = useRef(null);
  useEffect(function () {
    if (submitTimeout.current) {
      clearTimeout(submitTimeout.current);
    }
    submitTimeout.current = setTimeout(function () {
      var ref = formRef.current;
      ref && ref.submit();
    }, 100);
    return function () {
      if (submitTimeout.current) {
        clearTimeout(submitTimeout.current);
        submitTimeout.current = null;
      }
    };
  }, [props.formData]);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: "ripple"
  }, /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: messages,
    path: "SchemaForm/CVIReviewForm/locales/CVIReviewForm",
    namespace: "@dm/components.cvi-review-form"
  }, /*#__PURE__*/React.createElement(RecordEditorForm, Object.assign({}, props, {
    view: "PRINT",
    widgets: widgets,
    formRef: formRef
  }))));
}